/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    array, object,
} from 'prop-types';

import PLAPersonalizedRecsContainer from './PLAPersonalizedRecsContainer';

export default function PLARecsTypeParser({
    product, skuData, cmsRecBlockData,
}) {
    const moduleType = cmsRecBlockData?.show_module || '';

    // 6810; this parses query type from recommendations block field of standard_product content-type. although each current use case uses same query container, this structure allows easier changes in the future.
    switch (moduleType) {
        // 6810; keeping previous flow for this recs feature
        // case 'similar products':
        //     return (
        //         <PLARecsContainer
        //             product={product}
        //             skuData={skuData}
        //             isPlaRedesignEnabled={isPlaRedesignEnabled}
        //             cmsRecBlockData={cmsRecBlockData}
        //         />
        //     );
        case 'customers also viewed':
            return (
                <PLAPersonalizedRecsContainer
                    product={product}
                    skuData={skuData}
                    cmsRecBlockData={cmsRecBlockData}
                    recommendationType={PLAPersonalizedRecsContainer.recommendationTypes.CUSTOMERS_ALSO_VIEWED}
                    dataTestId="product-customer-also-viewed"
                />
            );
        case 'more category gifts':
            return (
                <PLAPersonalizedRecsContainer
                    product={product}
                    skuData={skuData}
                    cmsRecBlockData={cmsRecBlockData}
                    recommendationType={PLAPersonalizedRecsContainer.recommendationTypes.TRENDING}
                    dataTestId="product-category-gifts"
                />
            );
        case 'recently viewed':
            return (
                <PLAPersonalizedRecsContainer
                    product={product}
                    skuData={skuData}
                    cmsRecBlockData={cmsRecBlockData}
                    recommendationType={PLAPersonalizedRecsContainer.recommendationTypes.RECENTLY_VIEWED}
                    dataTestId="product-pla-recently-viewed"
                />
            );
        default:
            return null;
    }
}

PLARecsTypeParser.propTypes = {
    product: object.isRequired,
    skuData: array.isRequired,
    cmsRecBlockData: object,
};

PLARecsTypeParser.defaultProps = {
    cmsRecBlockData: {},
};
